

import React from "react";

const History2 = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M479.96-90Q329-90 217.58-190.28 106.16-290.56 91.5-440.5h76q14.5 119 103.8 197.25T480-165q131.5 0 223.25-91.75T795-480q0-131.5-91.75-223.25T480-795q-85.26 0-158.13 42.5Q249-710 206.5-635h115v75H98q29-136 135.97-223T480-870q80.91 0 152.07 30.76 71.15 30.77 123.79 83.5Q808.5-703 839.25-631.91 870-560.83 870-480q0 80.91-30.76 152.07-30.77 71.15-83.5 123.79Q703-151.5 631.9-120.75T479.96-90ZM589.5-317.5l-147-147.25V-674h75v179l125 124.5-53 53Z" />
        </svg>

    )
}

export default History2;